{
  "bool": {
    "enum": ["bool"]
  },
  "cstring": {
    "enum": ["cstring"]
  },
  "void": {
    "enum": ["void"]
  }
}
